export const clientUserDeleteModalId = 'clientUserDeleteModal';
export const clientUserFormModalId = 'clientUserFormModal';
export const clientUsersAlertId = 'clientUsersAlert';
export const clientUsersFilterFormId = 'clientUsersFilterForm';
export const clientUserPasswordResetModalId = 'clientUserPasswordResetModal';
export const clientUserSignatureResetModalId = 'clientUserSignatureResetModal';
